import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import SiteLayout from "./components/layout/SiteLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AuthCallback from "./components/auth/AuthCallback";
import { SERVICE_ROUTES } from "./data/content";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import Calculators from "./pages/Calculators";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import BookConsultation from "./pages/BookConsultation";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import Learn from "./pages/Learn";
import CoursePage from "./pages/CoursePage";
import LessonPage from "./pages/LessonPage";
import CertificatePage from "./pages/CertificatePage";
import QuizPage from "./pages/QuizPage";

const LEGAL_SLUGS = ["privacy-policy", "terms-and-conditions", "risk-disclosure", "regulatory-disclosures"];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        {SERVICE_ROUTES.map((s) => (
          <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage slug={s.slug} />} />
        ))}
        <Route path="/calculators" element={<Calculators />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/learn/:slug" element={<CoursePage />} />
        <Route path="/learn/:slug/quiz" element={<QuizPage />} />
        <Route path="/learn/:slug/:lessonId" element={<LessonPage />} />
        <Route path="/certificates/:id" element={<CertificatePage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-consultation" element={<BookConsultation />} />
        {LEGAL_SLUGS.map((s) => (
          <Route key={s} path={`/${s}`} element={<Legal slug={s} />} />
        ))}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </SettingsProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
